import CallToActionButtonContent from '@/components/landingPage/CallToActionButtonContent';

const CallToActionButton = ({
  buttonText,
  visibleOnMobile,
}: {
  buttonText?: string;
  visibleOnMobile?: boolean;
}) => {
  return (
    <div className={visibleOnMobile ? 'block' : 'md:block hidden'}>
      <CallToActionButtonContent defaultText={buttonText} />
    </div>
  );
};

export default CallToActionButton;
